import * as React from 'react'
import Image from '../../../../components/Image/Image'
import { cls } from '../../../../utils/utils'
import SimpleMarkdown from '../../../../components/SimpleMarkdown/SimpleMarkdown'
import { IProps } from './Testimonial.types'
import styles from './Testimonial.module.scss'

const Testimonial = (props: IProps) => {
  return (
    <div className={styles.testimonial}>
      <Image alt="Quotation marks" image={props.quotationMarks} className={styles.quotationMarks} />
      <SimpleMarkdown body={props.clientTestimonial} className={cls('text--small', styles.text)} />
      <div className={styles.client}>
        <div className={styles.photo}>
          <Image alt="Client photo" image={props.clientPhoto} />
        </div>
        <div className={styles.data}>
          <h3 className={styles.name}>{props.clientName}</h3>
          <div className={cls(styles.description, 'text--small')}>{props.clientDescription}</div>
        </div>
      </div>
    </div>
  )
}
export default Testimonial
